import { useState, useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { UserSegment } from './useUserState';
import utils from 'lib/utils';
import useUserState from 'lib/hooks/useUserState';

/**
 *
 * @param {*} isHatAudienceCondition
 * @returns {{
 *   user: any;
 *   segment: UserSegment;
 *   isHatAudience: boolean;
 *   classesUserSegment: 'classes' | 'canceled_classes' | 'none';
 * }}
 */
const useMarketingHat = (
  isHatAudienceCondition = ['anonymous', 'registrant'],
) => {
  const [user, setUser] = useState(null);
  const [segment, setSegment] = useState(null);
  const [classesUserSegment, setClassesUserSegment] = useState('none');
  const userData = useUserState();

  useEffect(() => {
    setUser(userData);
    const { active_memberships, cancelled_memberships, segment } =
      userData ?? {};

    if (active_memberships?.some((m) => ['classes', 'school'].includes(m))) {
      setClassesUserSegment('classes');
    } else if (
      cancelled_memberships?.some((m) => ['classes', 'school'].includes(m))
    ) {
      setClassesUserSegment('canceled_classes');
    }

    if (segment === 'cancelled_other') {
      const cancelledSchoolMembership = cancelled_memberships.every(
        (val) => !['atk', 'cio', 'cco'].includes(val),
      );
      if (cancelledSchoolMembership) {
        setSegment('registrant');
      } else {
        setSegment('former');
      }
    } else {
      setSegment(
        userData &&
          userData?.segment &&
          utils.getUserSegment(userData?.segment),
      );
    }
  }, [userData]);

  return {
    user,
    segment,
    classesUserSegment,
    isHatAudience: isHatAudienceCondition.includes(segment),
  };
};

export default useMarketingHat;
